import React from 'react';
import { Button } from '../../../../';
import { Form, Checkbox, Tooltip } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { NameField, UsernameField, PasswordField, DirectoryIdField } from '../../cloudAccountFields';
import { TestConnectionButton } from '../../cloudAccountFields';
import TagsSelector from '../../../../TagsSelector';
import { getHelpLink } from '../../utils/cloudAccountHelpers';
import './AzureCloudAccount.scss';

/**
 * Azure Cloud Account - Add Mode
 * Focused component for adding new Azure cloud accounts
 */
export const AzureCloudAccountAdd = ({
    formData,
    errors,
    onChange,
    onTestConnection,
    testing,
    tested,
    azureSPNData,
    onReuseExistingSPN,
    tags,
    onTagsChange,
    userOrg,
    setupAppliance,
    onSetupApplianceChange,
}) => {
    return (
        <>
            <NameField value={formData.name} onChange={onChange('name')} error={errors.name} />

            {/* Reuse Existing SPN Button */}
            {azureSPNData?.spn_exist && (
                <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={onReuseExistingSPN}
                        className="azure-reuse-button"
                    >
                        Reuse Existing SPN
                    </Button>
                </Form.Item>
            )}

            <DirectoryIdField
                value={formData.tenant_id}
                onChange={onChange('tenant_id')}
                error={errors.tenant_id}
                required={true}
            />

            <UsernameField
                value={formData.username}
                onChange={onChange('username')}
                label="Application ID"
                placeholder="Enter Application ID"
                error={errors.username}
                required={true}
            />

            <PasswordField
                value={formData.password}
                onChange={onChange('password')}
                label="Key Value"
                placeholder="Enter Key Value (required)"
                error={errors.password}
                required={true}
            />

            <div className="azure-helper-links">
                <a
                    href={getHelpLink('AZURE_APP_REGISTRATION_DOCS')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="azure-link"
                >
                    View Instructions
                </a>
            </div>

            {/* Test Connection - Required for Azure */}
            <TestConnectionButton
                onTest={onTestConnection}
                testing={testing}
                tested={tested}
                error={errors.testing}
                tooltip="Connection must be validated before you can Add Target Cloud. The connection and login credentials are tested (SSL certification is ignored)."
                required={true}
            />

            {/* Tags */}
            <Form.Item label="Tags">
                <TagsSelector value={tags} onChange={onTagsChange} userOrg={userOrg} />
            </Form.Item>

            {/* Setup Appliance */}
            <Form.Item>
                <Checkbox checked={setupAppliance} onChange={(e) => onSetupApplianceChange(e.target.checked)}>
                    Setup Migration Appliance for this target cloud{' '}
                    <Tooltip title="A Migration Appliance must be deployed for each target. Leave this checked to setup the Migration Appliance after you complete this form.">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </Checkbox>
            </Form.Item>
        </>
    );
};
